import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from "@angular/material/snack-bar";

import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-notification-bar",
  templateUrl: "./notification-bar.component.html",
  standalone: true,
  imports: [TranslateModule, MatButtonModule, MatIconModule, CommonModule],
  styleUrls: ["./notification-bar.component.scss"],
})
export class NotificationBarComponent {
  message: string = "";
  information?: string = "";

  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    private data: { message: string; information?: string },
    private snackBarRef: MatSnackBarRef<NotificationBarComponent>
  ) {
    this.message = this.data.message;
    this.information = this.data.information;
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
